const INTERNAL_PATH_PREFIXES = [
  '/rails/',
  '/assets/',
  '/packs/',
  '/vite/',
  '/@vite',
  '/system/',
  '/sockjs-node',
];

function shouldSkipLocaleInjection(pathname) {
  if (!pathname) return true;
  return INTERNAL_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function getCurrentLocale() {
  const langAttr = document.documentElement?.lang;
  if (!langAttr) return null;

  const normalized = langAttr.trim().toLowerCase();
  if (!normalized) return null;

  const base = normalized.split('-')[0];
  return base || null;
}

function ensureUrl(input) {
  if (input instanceof URL) {
    // Clone to avoid mutating caller-provided instance.
    return new URL(input.toString());
  }

  return new URL(String(input), window.location.origin);
}

export function buildLocalizedUrl(inputUrl) {
  if (!inputUrl) return inputUrl;

  try {
    const url = ensureUrl(inputUrl);
    const locale = getCurrentLocale();

    if (!locale) {
      return url;
    }

    // Only inject locale for same-origin requests that do not already have it.
    if (url.origin !== window.location.origin) {
      return url;
    }

    if (url.searchParams.has('locale') || shouldSkipLocaleInjection(url.pathname)) {
      return url;
    }

    url.searchParams.set('locale', locale);
    return url;
  } catch (error) {
    console.warn('Failed to build localized URL:', { inputUrl, error });
    return inputUrl;
  }
}
